<div class="flex justify-between items-center">
  <h1>New owner</h1>
  <sbnb-close (click)="close()"></sbnb-close>
</div>
<hospitable-statements-owner-form [(owner)]="owner"></hospitable-statements-owner-form>
<div class="flex items-center gap-4 justify-end">
  <sbnb-button type="secondary" (clicked)="close()" [disabled]="savingOwner$ | async">Cancel</sbnb-button>
  <sbnb-button (clicked)="saveOwner()" [disabled]="savingOwner$ | async">Create</sbnb-button>
</div>
